import React, { lazy } from "react";
import { Route } from "react-router-dom";
import MainLayout from "../../components/MainLayout/MainLayout";
import { AuthenticationGuard } from "@/components/AuthenticationGuard/AuthenticationGuard";
import PermissionGuard from "@/components/PermissionGuard/PermissionGuard";

const CustomerPipeline = lazy(
  () =>
    import(
      "@/modules/sales/features/CustomerPipeline/components/CustomerPipeline/CustomerPipeline"
    ),
);

const SalesMainLayout = () => <MainLayout section="sales" />;

const SalesRoutes = (
  <Route
    element={<AuthenticationGuard component={SalesMainLayout} />}
    path="/sales"
  >
    <Route
      element={
        <PermissionGuard
          requiredRoles={[
            "ROLE_SUPER_ADMIN",
            "ROLE_SALES_MANAGER",
            "ROLE_SALES_REP",
          ]}
        >
          <CustomerPipeline />
        </PermissionGuard>
      }
      index
    />
    <Route
      element={
        <PermissionGuard
          requiredRoles={[
            "ROLE_SUPER_ADMIN",
            "ROLE_SALES_MANAGER",
            "ROLE_SALES_REP",
          ]}
        >
          <CustomerPipeline />
        </PermissionGuard>
      }
      path="pipeline"
    />
  </Route>
);

export default SalesRoutes;
